import DeviceCard from "./DeviceCard";
import removeIcon from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/trash.png'
import Pill_Widget from "../../Widgets/Pill_Widget";
import { format } from "date-fns";
import signal100 from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/signal_100.png'
import signal75 from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/signal_75.png'
import signal50 from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/signal_50.png'
import signal25 from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/signal_25.png'
import signal0 from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/signal_0.png'
import signalLost from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/signal_lost_warning.png'

import battery0 from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/SensorIcons/battery_0.png'
import battery25 from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/SensorIcons/battery_25.png'
import battery50 from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/SensorIcons/battery_50.png'
import battery75 from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/SensorIcons/battery_75.png'
import battery100 from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/SensorIcons/battery_100.png'


import warning from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/yellow_warn.png'
import warningRed from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/red_warn.png'

import areYouSure from '../../../../assets/animations/areYouSure.json'
import Lottie from "lottie-react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { useState } from "react";
import { unlinkGateway } from "../../../../Api Methods/Api";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { Tooltip } from "primereact/tooltip";

const GatewayCard = ({gateway, apiData, siteUUID, showSuccess, refreshDevices}) => {
    const lastSeen = new Date(gateway.lastSeenAt)
    const linked = new Date(gateway.dateLinked)
    const lastSeenFormatted = format(lastSeen, "MMM do, yyyy")
    const linkedFormatted = format(linked, "MMM do, yyyy")
    const [showConfirm, setShowConfirm] = useState(false)
    const dispatch = useDispatch();
    
    const unlink = async () => {
        const responseData = await unlinkGateway(apiData, siteUUID, gateway.id, dispatch)
        if (responseData) {
            setShowConfirm(false)
            showSuccess(true)
            refreshDevices()
        }    
    }

    const batteryColours = (batteryLevel) => {
        let colour = "";
        if (batteryLevel > 0 && batteryLevel < 25) {
            // red
            colour = "rgb(220,114,119)"
        } else if (batteryLevel >= 25 && batteryLevel < 50) {
            //orange
            colour = "rgb(248,183,131)"
        } else if (batteryLevel >= 50){
            //green
            colour = "rgb(101,151,100)"
        } else {
            colour = "rgb(123, 123, 123)"
        }

        return colour;
    }

    const signalIcons = [
        signal100, 
        signal75, 
        signal50, 
        signal25, 
        signal0,
        signalLost
    ]

    const batteryIcons = [
        battery0,
        battery25,
        battery50,
        battery75,
        battery100
    ]

    let signalIcon;

    if (gateway.signal >= 75){
        signalIcon = signalIcons[0]
    } else if (gateway.signal >= 50 && gateway.signal < 75){
        signalIcon = signalIcons[1]
    } else if (gateway.signal >= 25 && gateway.signal < 50){
        signalIcon = signalIcons[2]
    } else if (gateway.signal >= 0 && gateway.signal < 25){
        signalIcon = signalIcons[3]
    } else {
        signalIcon = signalIcons[4]
    }

    const batteryColour = batteryColours(gateway.battery);

    

    const isStale = gateway.status == "potentiallyStale"
    const isOffline = gateway.status == "stale"
    
    return (
        <>

        <Dialog
            header="Are you sure?"
            visible={showConfirm}
            style={{ width: "40vw" }}
            onHide={() => setShowConfirm(false)}
        >
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>

                <Lottie
                    animationData={areYouSure}
                    loop={false}
                    style={{ width: 150, height: 150, margin: "0px" }}
                />
                <br />
                <h3 style={{ color: "#6e6e6eff" }}>{`Are you sure you want to unlink this Gateway?`}</h3>
                <br />
                <Button label="No cancel" icon="pi pi-times" severity="secondary" onClick={() => setShowConfirm(false)} />
                <br />
                <Button label="Yes, unlink" icon="pi pi-check" severity="danger" onClick={() => unlink()} />

            </div>
        </Dialog>
        
        <DeviceCard
            header={`Gateway`}
            meta={[<Link
                            to={`/Dashboard/Gateways/Gateway/${gateway.IMEI}`}
                        >{gateway.IMEI}</Link>,
                    <p style={{marginTop:6, marginBottom:0}}>
                        Linked: {linkedFormatted}
                    </p>, 
                    <p style={{marginTop:6, marginBottom:0, color: isOffline ? "#FF0000" : "#818181"}}>
                        Last updated: {lastSeenFormatted}
                    </p>]}
            rightContent={
                <>
                    <div style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "flex-end",
                        gap:"5px"
                    }}>
                        <div style={{display:"flex", flexDirection:"row", alignItems:"center", gap:"7px"}}>
                        {/* <Pill_Widget boolean={true} PillColor_IfTrue={batteryColours(gateway.battery)} PillColor_IfFalse={"#626a67"} text_IfTrue={gateway.battery != 0 ? gateway.battery + "%" : "?"} /> */}
                       
                            {isOffline && <Tooltip target=".gateway-battery-icon" content={`This is the last known battery, which is from the last updated date: ${lastSeenFormatted}`} position="top" />}
                            <div className={isOffline ? "gateway-battery-icon" : ""} style={{ position: "relative", width: 45, height: 45 }}>
                                <p style={{ position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center", margin: 0, fontWeight: 600, color: "#ffffff", fontSize: 12, zIndex: 1 }}>{gateway.battery !== 0 ? `${gateway.battery}%` : "?"}</p>
                                <div style={{
                                    width: 45,
                                    height: 45,
                                    backgroundColor: batteryColour,
                                    WebkitMaskImage: `url(${battery100})`,
                                    WebkitMaskSize: "contain",
                                    WebkitMaskRepeat: "no-repeat",
                                    WebkitMaskPosition: "center",
                                    maskImage: `url(${battery100})`,
                                    maskSize: "contain",
                                    maskRepeat: "no-repeat",
                                    maskPosition: "center",
                                }} />
                            </div>
                        
                        {/* <img src={signalIcon} style={{width:"25px"}} /> */}
                        <div style={{ position: "relative", width: 27, height: 27 }}>
                            <img src={signalIcon} style={{ width: 27, height: 27 }} />
                            {isStale && <img src={warning} style={{ width: 27, height: 27, position: "absolute", bottom: 0, right: 0 }} />}
                            {isOffline && <img src={warningRed} style={{ width: 27, height: 27, position: "absolute", bottom: 0, right: 0 }} />}
                        </div>
                    </div>
                    </div>
                    
                    <img src={removeIcon} style={{width:"25px", cursor:"pointer"}} onClick={() => setShowConfirm(true)}/>
                </>
            } 
        />
    </>
    );
}

export default GatewayCard;